import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * 体験版 問題選択肢クラス
 */
@JsonObject('TrialChoice')
export default class TrialChoice {
  constructor() {
    this.choiceCode = '';
    this.choiceTitle = '';
    this.collectType = '';
    this.order = 0;
  }

  @JsonProperty('choice_code')
  public choiceCode: string;

  @JsonProperty('choice_title')
  public choiceTitle: string;

  @JsonProperty('collect_type')
  public collectType: string;

  @JsonProperty('order')
  public order: number;
}
